export default "__VITE_ASSET__iNV07T2z__"